import React from "react";

export const AnnouncementDetailContext = React.createContext(null);

export const useAnnouncementDetailContext = () => {
  const context = React.useContext(AnnouncementDetailContext);

  if (!context) throw new Error("Announcement Detail Context not provided!");

  return context;
};
